module.exports = "https://images.shiksha.ws/saassets/media/instagram_hover.e7d09e06.svg";